//Confirmation Modal, combines all other confirmation modals
define(function (require) {
    const tpl = require('./t_lov_confirmation_modal.hbs');
    const log_model = require('civicsModels/log_model');
    const ViewManager = require('civicsUtils/view_manager');
    const utils = require('civicsUtils/general_utilities');

    return Marionette.LayoutView.extend({
        className:'confirmation-modal',
        template:tpl,
        events: {
            'click @ui.cancelButton':'cancelClicked',
            'click @ui.closeButton':'cancelClicked',
            'click @ui.submitButton':'submitClicked'
        },
        ui: {
            comments:'.log-comments .input-textarea',
            cancelButton:'.cancel-button',
            submitButton:'.submit-button',
            closeButton:'.bbm-btn-close'
        },
        initialize: function (options) {
            var self = this;
            // The following are the options that can be used to change what is displayed in the
            // confirmation view. If the type is not specified as <t/f> (boolean) or an array,
            // should set option property to a string value. They are listed in order of top to
            // bottom when displayed in hbs

            // _______________OPTIONS___________________________________
            // displayPrintButton: <t/f>, display top-right print button
            // title
            // instructions
            // applicationTitle: bold title of application/record/instrument
            // selectedChildApps: array of {
            //     applicationNumber: ???, //id
            //     applicationTypePortalDescription: ???,
            //     applicationTypeDescription: ???
            //  }; list of apps to display
            // childItems: set to an array [{
            //     title: ???,
            //     description: ???
            //  },...]; //list of items to display in a scrollable div
            // text: text to display
            // displayStatusDropdown: <t/f>
            // statusCodes: set to an array [{
            //     code: ???,
            //     description: ???
            //  },...]; //status codes to use for dropdown
            // statusLabel: change 'Status' header to another name
            // displayDateTime: <t/f>, display datetime input fields
            // dateLabel: change 'Date' header to another name
            // timeLabel: change 'Time' header to another name
            // hideSubmitButton: <t/f>
            // displayCommentsSection: <t/f>, display comments textarea
            // flexButtons: <t/f>, stretch submit/cancel buttons to width of modal window
            // buttonAlignRight: <t/f>, align submit/cancel to the right
            // submitButtonText: change 'Submit' button text to something else
            // cancelButtonText: change 'Cancel' button text to something else
            // textareaLabelText: Set label text of textarea
            // optionalText: Set 'Optional' label text of textarea

            // The following are functionality options:
            // logData: if passed, will create log on submit
            // confirmationCallback: a function to run once submit clicked

            var logData = options.logData;
            //  logData example: {
            //     type: ???,//type of log
            //     instrumentType: ???,
            //     instrumentID: ???
            //     parentView: ???//view creating this modal
            //     preText: ???//text to prefix log message (message = preText+logComments)
            //  }
            if(logData){
                this.createLog = true;//If logData passed, create log on submission
                this.type = logData.type;
                this.instrumentType = logData.instrumentType;
                this.instrumentID = logData.instrumentID;
                this.parentView = logData.parentView;
                this.preText = (logData.preText) ? logData.preText:'';//used to prefix the log comments
            }
			this.modalRegion = options.modalRegion;

            this.confirmationCallback = options.confirmationCallback;//Callback function after submit (and log creation)
            if(!this.confirmationCallback){
                this.confirmationCallback = function(){
                    if(__DEV__){ console.log('No callback assigned to confirmation modal') }
                    this.cancelClicked();
                };
            }
			this.cancellationCallback = options.cancellationCallback;//Callback function after cancel (and log creation)
            if(!this.cancellationCallback){
                this.cancellationCallback = function(){
                    if(__DEV__){ console.log('No callback assigned to cancellation modal') }
                };
            }
			this.closeCallback = options.closeCallback;//Callback function after close (and log creation)
            if(!this.closeCallback){
                this.closeCallback = function(){
                    if(__DEV__){ console.log('No callback assigned to close modal') }
                };
            }
        },
        onShow:function(){

          $(this.ui.comments).maxlength();
        },
        onRender:function(){
            this.$el.rhythmThemeInit();
        },
        submitClicked:function(){
			this.confirmed = true;
            if(this.createLog){//create a new log
                this.createNewLog();//confirmationCallback will be called upon completion
            } else {
                this.confirmationCallback();
				if(this.options.closeAfterSubmit === true){
					this.closeModal();
				}
            }
        },
        cancelClicked: function(e) {
			if(e){
				e.stopPropagation();
				e.preventDefault();
				
			}
			this.cancellationCallback();
			this.closeModal();
		},
		closeModal:function(){
            if(this.modalRegion) {
                this.modalRegion.hideModal(()=>{
					this.closeCallback(this.confirmed === true);
				});
            }
            else {
                this.destroy();
            }
        },
        createNewLog: function(){
            ViewManager.loading(true);
            var model = new log_model();
            model.instrumentType = this.instrumentType;
            model.set({
                logType:this.type,
                startDateTime:utils.dateTimeStringFromDate(new Date()),//isoFixed
                comments:this.preText+this.ui.comments.val(),
                application:this.instrumentID
            });
            model.save(null,{
                success:function(r,m,o){
                    console.log(r);
                    //if this view is opened from an item view, we have to use global regions,
                    //which don't allow for parent view functionality, like trigger method. To get around that,
                    //we pass in a reference to the parent view directly.
                    if(this.parentView){
                        this.parentView.createdLog(r);
                    } else {
                        this.triggerMethod('createdLog', r)
                    }
                    this.confirmationCallback();//destroy called in callback
                    ViewManager.loading(false);
                }.bind(this),
                error: function(model, response, options){
                    ViewManager.errorToWindow(response, this);
                    this.cancelClicked();
                    ViewManager.loading(false);
                }.bind(this)
            })
        },
        templateHelpers:function(){
            var options = this.options;
            // selectedChildApps example: [{
            //     applicationNumber: ?,
            //     applicationTypePortalDescription: ?,
            //     applicationTypeDescription: ?
            // },...]
            return {//in order of top items to bottom items in .hbs
                displayPrintButton: options.displayPrintButton,
                title: options.title,
                instructions: options.instructions,
                applicationTitle: options.applicationTitle,
                selectedChildApps: options.selectedChildApps,
                childItems: options.childItems,
                text: options.text,
                displayStatusDropdown: options.displayStatusDropdown,
                statusCodes: options.statusCodes,
                statusLabel: options.statusLabel ? options.statusLabel : i18n.t('CIVICS.COMMON.STATUS'),
                displayDateTime: options.displayDateTime,
                dateLabel: options.dateLabel ? options.dateLabel : i18n.t('CIVICS.COMMON.DATE'),
                timeLabel: options.timeLabel ? options.timeLabel : i18n.t('CIVICS.COMMON.TIME'),
                displaySubmitButton: !options.hideSubmitButton,
                displayCancelButton: !options.hideCancelButton,
                displayCommentsSection: options.displayCommentsSection,
                flexButtons: options.flexButtons,
                buttonAlignRight: options.buttonAlignRight,
                submitButtonText: options.submitButtonText ? options.submitButtonText : i18n.t('CIVICS.COMMON.SUBMIT'),
                cancelButtonText: options.cancelButtonText ? options.cancelButtonText : i18n.t('CIVICS.COMMON.CANCEL'),
                textareaLabelText: options.textareaLabelText,
                optionalText: options.optionalText
            }
        }
    });
});
